var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSleepStyleSideGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58.269,
    height: 104.497,
    viewBox: "0 0 58.269 104.497",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4400",
    "data-name": "Rectangle 4400",
    width: 58.269,
    height: 104.497,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2917",
    "data-name": "Group 2917",
    transform: "translate(0 0)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2846",
    "data-name": "Group 2846",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6964",
    "data-name": "Path 6964",
    d: "M6.446,33.734l2.573-.574a172.159,172.159,0,0,1,35.315-4.117,2.932,2.932,0,0,0,2.792-3.7l-.717-2.634A62.944,62.944,0,0,1,44.276,3.078a2.932,2.932,0,0,0-3.594-3l-.457.106A172.159,172.159,0,0,1,5.026,4.63l-2.157.048A2.932,2.932,0,0,0,.113,8.408l.476,1.684A62.946,62.946,0,0,1,2.922,29.554l-.045,1.21a2.932,2.932,0,0,0,3.569,2.97",
    transform: "translate(0 0)",
    fill: "#d7e9f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6965",
    "data-name": "Path 6965",
    d: "M61.507,179.7c-.419-.224-.636,2.533-.636,2.533s-.786-4.91-1.046-5.768-1.669,1.442-1.595,1.3c-.558-.3-1.166,1.172-1.1,1.387-1.062-.029-.672,1.257-1.39,1.591-.269,1.8,1.178,4.634,1.843,5.817l-.019.007a25.2,25.2,0,0,1,2.245,5.762,46.8,46.8,0,0,0,4.957-1.09l-2.239-4.964a3.605,3.605,0,0,1-.247-2.089c.249-1.475-.434-4.307-.773-4.489",
    transform: "translate(-47.88 -151.508)",
    fill: "#ef8062"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6966",
    "data-name": "Path 6966",
    d: "M90.574,287.759s-2.664-9.99-5.728-10.523-6.926,0-6.926,1.731,5.594,9.99,7.459,11.722,5.195-2.93,5.195-2.93",
    transform: "translate(-66.972 -238.115)",
    fill: "#566b15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6967",
    "data-name": "Path 6967",
    d: "M222.6,454.056c.133.533,1.332,5.461-.533,8.791s-13.187-7.326-13.187-7.326l-.133-4.529Z",
    transform: "translate(-179.422 -387.628)",
    fill: "#ff9976"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6968",
    "data-name": "Path 6968",
    d: "M32.38,545.116,26.907,530.47l6.767-2.5,2.483,14.076a5.551,5.551,0,0,0,1.426,2.865,8.381,8.381,0,0,1,1.767,2.675,1.657,1.657,0,0,1-.667,2.126L27.97,554.792c-.6.263-1.278-.5-1.043-1.179.345-.991,1.558-1.927,2.994-4.02a16.093,16.093,0,0,1,1.982-2.4,1.95,1.95,0,0,0,.477-2.076",
    transform: "translate(-23.103 -453.794)",
    fill: "#ef8062"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6969",
    "data-name": "Path 6969",
    d: "M19.483,454.009s-.8,15.185,2.4,15.984,7.992-.533,8.791-3.2-.266-6.393-.266-6.393,12.521,15.079,21.845,10.55c7.08-3.439-21.845-22.8-21.845-22.8Z",
    transform: "translate(-16.669 -385.184)",
    fill: "#566b15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6970",
    "data-name": "Path 6970",
    d: "M60.334,567.2l-6.478-14.229,6.577-2.961,3.456,13.87a5.553,5.553,0,0,0,1.622,2.758,8.382,8.382,0,0,1,1.949,2.545,1.657,1.657,0,0,1-.518,2.167L56.608,577.16c-.58.3-1.31-.413-1.122-1.1.275-1.013,1.421-2.031,2.707-4.219A16.088,16.088,0,0,1,60,569.305a1.95,1.95,0,0,0,.331-2.1",
    transform: "translate(-46.289 -472.735)",
    fill: "#ff9976"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6971",
    "data-name": "Path 6971",
    d: "M158.8,203.139s1.379,4.36,3.478,4.784c-.64,2.775-3.975,5.433-7.129,4.423s-3.513-6.092-3.513-6.092Z",
    transform: "translate(-130.335 -174.598)",
    fill: "#ff9976"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6972",
    "data-name": "Path 6972",
    d: "M153,222.055a5.119,5.119,0,0,0,2.522-3.229,1.794,1.794,0,0,0-1.035-2.339l-2.851,1.239A10.561,10.561,0,0,0,153,222.055",
    transform: "translate(-130.335 -186.071)",
    fill: "#ef8062"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6973",
    "data-name": "Path 6973",
    d: "M50.59,200.332c-.448-.158-.245,2.6-.245,2.6s-1.522-4.734-1.909-5.542-1.431,1.679-1.379,1.529c-.6-.211-.975,1.336-.878,1.538-1.054.132-.474,1.344-1.132,1.784.008,1.825,1.867,4.4,2.7,5.47l-.017.01a25.2,25.2,0,0,1,3.093,5.355,46.79,46.79,0,0,0,4.734-1.829l-2.547-3.921a6.455,6.455,0,0,1-.992-3.017c-.122-1.531-1.1-3.858-1.432-3.976",
    transform: "translate(-38.719 -169.517)",
    fill: "#ff9976"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6974",
    "data-name": "Path 6974",
    d: "M82.657,237.8a2.313,2.313,0,0,1,3.064.666c1.2,1.732,3.33,5.461,3.33,5.461s-.4-5.594,1.2-7.992,7.459-7.326,10.39-6.926,9.59,4.4,11.722,11.588,3.463,20.513,1.332,23.976-11.855,4.662-14.386,3.6-6.793-6.394-6.793-6.394l.266-4s-1.865,1.732-3.33.932-11.056-14.119-10.656-16.916,3.863-4,3.863-4",
    transform: "translate(-67.713 -196.812)",
    fill: "#b1d34a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6975",
    "data-name": "Path 6975",
    d: "M161.568,464.661c-9.59-3.863-12.282-1.078-15.451-1.4l4.271-.893s4.262,5.328,6.793,6.394c1.611.678,6.134.438,9.76-.719-.609-1.047-4.17-2.9-5.373-3.383",
    transform: "translate(-125.588 -397.407)",
    fill: "#566b15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6976",
    "data-name": "Path 6976",
    d: "M43.061,440.354s22.766,8.278,6.674,19.157c-5.209,3.522-22.254-10.973-22.254-10.973s2.038,4.65,2.075,7.6c.027,2.121-4.2,3.968-6.576,4.838a1.861,1.861,0,0,1-2.307-.912c-2.368-4.732-9.463-19.655-6.393-22.732,3.661-3.669,11.125-2.983,14.626-2.648,3.129.3,14.154,5.672,14.154,5.672",
    transform: "translate(-11.623 -373.37)",
    fill: "#b1d34a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6977",
    "data-name": "Path 6977",
    d: "M128.89,137.543s-2.542,6.389-8.4,4.513-5.188-14.825-1.538-16.14,11.7,2.255,9.937,11.627",
    transform: "translate(-99.83 -107.999)",
    fill: "#ff9976"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6978",
    "data-name": "Path 6978",
    d: "M112.258,72.574a3.606,3.606,0,0,0-3.772-3.2c-2.222.144-7.052-.583-5.975-5.9,1.627-8.029,10.324-8.085,17.7-6.012,7.092,1.993,9.932-7.748,15.339-6.017s16.525,15.922,6.922,20.287c-8.791,4-12.692.079-16.783,2s-6.313,4.013-10.5,3.2c-1.961-.38-2.7-2.362-2.932-4.361",
    transform: "translate(-87.975 -44.041)",
    fill: "#221e3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6979",
    "data-name": "Path 6979",
    d: "M176.646,365.649a30.54,30.54,0,0,0,3.454-11.161c.666,4-2.264,13.453-3.6,13.32-.4-.533.142-2.159.142-2.159",
    transform: "translate(-151.579 -304.683)",
    fill: "#578193"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleepStyleSideGreen);
export default __webpack_public_path__ + "static/media/sleepStyleSideGreen.f2e1ba143a0c26b5cf5d47f2600a4a8e.svg";
export { ForwardRef as ReactComponent };